import React, { useState, useEffect, useRef } from "react";
import NavigationViewWithGrid from "./NavigationViewWithGrid";
import { Stage, Layer, Rect, Image } from "react-konva";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";

function NavigationTabination(props) {
  const {
    pages,
    navigation,
    section,
    currentPageId = null,
    parentIsActive = null,
    imgSize = null,
  } = props;

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box
      key={parentIsActive ? "active" : "inactive"}
      sx={{
        display: "flex",
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          marginInline: "auto",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          orientation="horizontal"
          variant="scrollable"
          centered={false}
          aria-label="change between subnavigation maps"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          {navigation &&
            navigation.length > 0 &&
            navigation.map((navItem, index) => (
              <Tab
                key={`navigation-tab-${index}`}
                label={`Item ${index + 1}`}
                id={`navigation-tab-${index}`}
                aria-controls={`navigation-tab-${index}`}
                sx={{
                  minWidth: "auto",
                  backgroundColor: `${value === index ? "#013BB1" : "#fff"}`,
                  color: "#000",
                  "&.Mui-selected": {
                    color: "#fff",
                  },
                  borderTopLeftRadius: `${index === 0 ? "4px" : "0px"}`,
                  borderTopRightRadius: `${
                    index === navigation.length - 1 ? "4px" : "0px"
                  }`,
                  borderTop: `${index > 0 ? "1px solid #e0e0e0" : "none"}`,
                }}
              />
            ))}
        </Tabs>
        {navigation &&
          navigation.length > 0 &&
          navigation.map((navItem, index) => (
            <div
              key={`navigation-tab-${index}`}
              className="shadow-md"
              role="tabpanel"
              style={{
                display: value === index ? "block" : "none",
                height: "100%",
                width: "fit-content",
              }}
              id={`simple-tabpanel-${index}`}
              aria-labelledby={`simple-tab-${index}`}
            >
              <NavigationViewWithGrid
                pages={pages}
                navigation={navItem}
                image={navItem.image}
                section={section}
                currentPageId={currentPageId}
                isActive={value === index && !!parentIsActive}
                parentIsActive={
                  parentIsActive == null || parentIsActive === true
                }
                imgSize={imgSize}
              />
            </div>
          ))}
      </div>
    </Box>
  );
}

export default NavigationTabination;
